import React from 'react';
import type { InputHTMLAttributes } from 'react';
import { Tooltip } from './Tooltip';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  required?: boolean;
  /** Optional contextual help shown as a hover/focus tooltip beside the label */
  hint?: string;
}

export function Input({
  label,
  error,
  required,
  hint,
  id,
  ...rest
}: InputProps): React.ReactElement {
  const inputId = id ?? `input-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className={`input-group${error ? ' input-group--error' : ''}`}>
      <label htmlFor={inputId} className="input-group__label">
        {label}
        {required && <span className="input-group__required" aria-hidden="true">*</span>}
        {hint && (
          <Tooltip content={hint}>
            <span className="help-icon" aria-hidden="true">?</span>
          </Tooltip>
        )}
      </label>
      <input
        id={inputId}
        className="input-group__input"
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : undefined}
        required={required}
        {...rest}
      />
      {error && (
        <span id={`${inputId}-error`} className="input-group__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
